"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _scrollToElement = _interopRequireDefault(require("scroll-to-element"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The A11ySkipLinks component
 */
var A11ySkipLinks = /*#__PURE__*/function (_React$Component) {
  _inherits(A11ySkipLinks, _React$Component);

  var _super = _createSuper(A11ySkipLinks);

  function A11ySkipLinks() {
    var _this;

    _classCallCheck(this, A11ySkipLinks);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onSkipToNavigation", function (e) {
      return _this.skipTo(_this.props.skipToNavigationId, 'a, button', e);
    });

    _defineProperty(_assertThisInitialized(_this), "onSkipToContent", function (e) {
      return _this.skipTo(_this.props.skipToContentId, 'h1', e);
    });

    return _this;
  }

  _createClass(A11ySkipLinks, [{
    key: "skipTo",

    /**
     * Check to see if href contains any child tags
     * if so then we need to jump to the first item
     * otherwise default to the current href. In order
     * for this to work on the first item to jump to
     * it must have tabIndex=0 or be a A or Button element.
     *
     * @param skipId The id of the element to jump to
     * @param findChild optionally find first element match to jump to
     * @param e The event
     */
    value: function skipTo(skipId, findChild, e) {
      e.preventDefault();
      var ownerDocument = e.target.ownerDocument;
      var navElem = ownerDocument.getElementById(skipId.replace('#', ''));

      if (navElem) {
        var firstAnchor = navElem.querySelector(findChild);

        if (firstAnchor) {
          firstAnchor.focus();
          (0, _scrollToElement.default)(firstAnchor, {
            offset: -30,
            duration: 800
          });
        } else {
          navElem.focus();
          (0, _scrollToElement.default)(navElem, {
            offset: -30,
            duration: 800
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          skipToNavigationId = _this$props.skipToNavigationId,
          skipToNavigationLabel = _this$props.skipToNavigationLabel,
          skipToContentId = _this$props.skipToContentId,
          skipToContentLabel = _this$props.skipToContentLabel;
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "skip-links",
        className: "skip-links"
      }, /*#__PURE__*/_react.default.createElement("ul", null, skipToNavigationId && /*#__PURE__*/_react.default.createElement("li", {
        className: "skip-item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "skip-link",
        href: skipToNavigationId,
        onClick: this.onSkipToNavigation
      }, skipToNavigationLabel)), skipToContentId && /*#__PURE__*/_react.default.createElement("li", {
        className: "skip-item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "skip-link",
        href: skipToContentId,
        onClick: this.onSkipToContent
      }, skipToContentLabel))));
    }
  }]);

  return A11ySkipLinks;
}(_react.default.Component);

A11ySkipLinks.defaultProps = {
  skipToNavigationId: '',
  skipToNavigationLabel: 'Skip to navigation',
  skipToContentId: '',
  skipToContentLabel: 'Skip to main content'
};
A11ySkipLinks.propTypes = {
  skipToNavigationId: _propTypes.default.string,
  skipToNavigationLabel: _propTypes.default.string,
  skipToContentId: _propTypes.default.string,
  skipToContentLabel: _propTypes.default.string
};
var _default = A11ySkipLinks;
exports.default = _default;
//# sourceMappingURL=A11ySkipLinks.js.map